import React from "react";
import "./ExperienceAccordion.css";
import { DarkTheme, LightTheme, ThemeProvider } from "baseui";
import { style } from "glamor";

function ExperienceAccordion(props) {
  const theme = props.theme;
  const styles = style({
    backgroundColor: `${theme.accentBright}`,
    display: "block",
    margin: "10px auto", // Center the links horizontally
    textDecoration: "none",
    color: theme.text,
    textAlign: "center",
    paddingRight: "20px", // Add right padding for spacing
    ":hover": {
      boxShadow: `0 5px 15px ${theme.accentBright}`,
    },
  });
  return (
    <div>
      <div className="experience-accord">
        <ThemeProvider theme={theme.name === "light" ? LightTheme : DarkTheme}>
          <h1 className="educations-header" style={{ color: theme.text }}>
            Gallery
          </h1>
        </ThemeProvider>
      </div>
      <div className="educations-body-div">
        <div className="gallery">
          {/* Assuming you have image files in public/nails */}
          <div className="gallery-item">
            <img
              src={`${process.env.PUBLIC_URL}/fashion/1.jpg`}
              alt="Image 1"
              className="gallery-image"
            />
          </div>
          <div className="gallery-item">
            <img
              src={`${process.env.PUBLIC_URL}/fashion/2.jpg`}
              alt="Image 2"
              className="gallery-image"
            />
          </div>
          <div className="gallery-item">
            <img
              src={`${process.env.PUBLIC_URL}/fashion/3.jpg`}
              alt="Image 3"
              className="gallery-image"
            />
          </div>
          <div className="gallery-item">
            <img
              src={`${process.env.PUBLIC_URL}/fashion/4.jpg`}
              alt="Image 4"
              className="gallery-image"
            />
          </div>
          <div className="gallery-item">
            <img
              src={`${process.env.PUBLIC_URL}/fashion/5.jpg`}
              alt="Image 5"
              className="gallery-image"
            />
          </div>
          <div className="gallery-item">
            <img
              src={`${process.env.PUBLIC_URL}/fashion/6.jpg`}
              alt="Image 6"
              className="gallery-image"
            />
          </div>
          {/* Video */}
          <div className="gallery-item">
            <video controls className="gallery-video" width={"100%"}>
              <source
                src={`${process.env.PUBLIC_URL}/nails/video.mp4`}
                type="video/mp4"
              />
            </video>
          </div>
        </div>
        <div className="links">
          <h1 className="educations-header" style={{ color: theme.text }}>
            Links
          </h1>
          <a
            {...styles}
            className="general-btn"
            href={
              "https://docs.google.com/document/d/1rSJC3PGi7NxkK7pHIlXB2Nmp8y3e5wZT44qCjKNKTBU/edit?usp=drive_link"
            }
          >
            See my Resume
          </a>
          <a
            {...styles}
            className="general-btn"
            href={"https://www.instagram.com/tojusfashion/"}
          >
            Instagram Page
          </a>
          <a
            {...styles}
            className="general-btn"
            href={
              "https://www.etsy.com/shop/CustommadebyToju?ref=seller-platform-mcnav"
            }
          >
            Etsy Shop
          </a>
          <a
            {...styles}
            className="general-btn"
            href={"https://tojusfashion.com/"}
          >
            Book An Appointment
          </a>
        </div>
      </div>
    </div>
  );
}

export default ExperienceAccordion;
